import React from 'react';
import "./DatesIcon.css";
const DatesIcon = ({ data }) => {
  return <div className="dates-container">{data}</div>;
};

export default DatesIcon
